import styled, { css } from 'styled-components';

export const ContainerRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const ContainerColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const EditorContainer = styled.div`
  width: 100%;
  padding-bottom: 5px;
`;

export const QuillContainer = styled.div`
  background-color: white;
  margin-bottom: 5px;
`;

export const CommentContainer = styled.div.attrs({ className: 'darkModeSupport' })`
  width: 100%;
  background-color: white;
  border-radius: 1rem 5px 5px 5px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  ${({ isRootComment }) => {
    return css`
      padding: 5px ${isRootComment ? '5px' : '0px'} 0px 5px;
    `;
  }}
`;

export const CommentThumbnailColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  user-select: none;
`;

export const CommentThumbnail = styled.div`
  border-radius: 50%;
  min-width: 2rem;
  min-height: 2rem;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url(${({ accountThumbnail }) => accountThumbnail || ''});
`;

export const ThumbnailLineBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
`;

export const ThumbnailLine = styled.div`
  height: 100%;
  background-color: lightgray;
  width: 1px;
`;

export const ThumbnailLineSpacer = styled.div`
  height: 1rem;
`;

export const CommentColumn = styled.div`
  margin-left: 10px;
  width: 100%;
`;

export const CommentPoster = styled.a`
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  color: #295c88;

  &:hover {
    color: #448ac7;
    text-decoration: underline;
  }
`;

export const DateText = styled.label`
  font-size: 0.8rem;
  color: #448ac7;
`;

export const AlignBox = styled.div`
  // align-box to use when content divided left and right
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AlignBoxLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  gap: 5px;
`;

export const AlignBoxRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  gap: 5px;
`;

export const FooterAlignBox = styled(AlignBox)`
  user-select: none;
  margin-bottom: 2px;
`;

export const FooterButtonContainer = styled.button`
  padding: 0px 2px;
  border: 0;
  line-height: 0;
  height: 1.2rem;
  background: transparent;
  color: gray;
  &:hover {
    border-radius: 5px;
    ${({ hoverColor, hoverBackgroundColor }) => {
      return css`
        color: ${hoverColor || 'black'};
        background-color: ${hoverBackgroundColor || 'lightgray'};
      `;
    }}
  }
`;

export const FooterButtonIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  margin-right: 5px;
  font-size: 1rem;
`;

export const FooterButtonLabel = styled.label`
  font-size: 0.8rem;
  cursor: pointer;
  margin: 0;
`;
